// Utfällbara grupper (filterlådan). Knappen bär aria-expanded och det
// hopfällda innehållet är inert, så att dolda kryssrutor inte kan få fokus
// (tillgänglighetsgranskningen, issue #348).
function setState(toggle: Element, target: HTMLElement, visible: boolean) {
  target.dataset.uiVisible = visible.toString()
  target.toggleAttribute('inert', !visible)
  toggle.setAttribute('aria-expanded', visible.toString())
  if (visible) {
    toggle.setAttribute('data-ui-open', '')
  } else {
    toggle.removeAttribute('data-ui-open')
  }
}

function Accordion() {
  document.querySelectorAll('[data-ui-accordion]').forEach((accordion) => {
    const target = accordion.getAttribute('data-ui-target')
    const targetElement = target
      ? (document.querySelector(target) as HTMLElement | null)
      : null

    if (!targetElement) {
      return
    }

    // Se till att startläget stämmer även om mallen inte satt inert
    setState(accordion, targetElement, targetElement.dataset.uiVisible === 'true')

    accordion.addEventListener('click', () => {
      setState(accordion, targetElement, targetElement.dataset.uiVisible !== 'true')
    })
  })
}

export default Accordion
